import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import { ModalExibirConvidadosSessaoQuery } from '../../../graphql/Sessao';
import { Query, withApollo } from "react-apollo";

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    titulo: {
        fontSize: '25px'
    },
    subtitulo: {
        marginTop: '25px',
        marginBottom: '25px',
        fontSize: '20px'
    },
    buttonsActionWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    modalTitle: {
        paddingBottom: '10px',
    },
    rowUsuarios: {
        paddingTop: '5px',
        paddingBottom: '5px',
    },
    rowGrupos: {
        paddingTop: '5px',
        paddingBottom: '10px',
    }
});

class ExibirConviadosSessao extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
        }

    }

    render() {
        const { classes, handleModalClose , sessionId} = this.props;
        return (

            <Query query={ModalExibirConvidadosSessaoQuery} variables={{ sessionId }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...';
                    if (error) return `Error! ${error.message}`;

                    const { sessaoOne } = data;

                    sessaoOne.convidadosApenasUsuarios = sessaoOne.convidados.filter( el => el.usuario );
                    sessaoOne.convidadosApenasGrupos = sessaoOne.convidados.filter( el => !el.usuario );

                    return (
                        <Paper className={classes.root}>
                            <Container style={{minWidth: 500}}>
                                <Row>
                                    <Col className={classes.headerWrapper}>
                                        <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                                    </Col>
                                </Row>

                                <Row className={classes.modalTitle}>
                                    <Col>
                                        <Typography className={classes.titulo}>Convidados da sala {sessaoOne.nome}</Typography>
                                    </Col>
                                </Row>

                                { sessaoOne.convidadosApenasUsuarios.length > 0 ? (
                                    <Row className={classes.rowUsuarios}>
                                        <Col md="2">
                                            <strong>Usuários:</strong>
                                        </Col>
                                        <Col md="8">
                                            {sessaoOne.convidadosApenasUsuarios.map( el =>{
                                                return <Row key={el.id}>{el.usuario.nome}</Row>
                                            })}
                                        </Col>
                                    </Row>
                                ) : '' }

                                { sessaoOne.convidadosApenasGrupos.length > 0 ? (
                                    <Row className={classes.rowGrupos}>
                                        <Col md="2">
                                            <strong>Grupos:</strong>
                                        </Col>
                                        <Col md="8">
                                            {sessaoOne.convidadosApenasGrupos.map( el =>{
                                                return <Row key={el.id}>{el.grupo.nome}</Row>
                                            })}
                                        </Col>
                                    </Row>
                                ) : '' }
                            </Container>
                        </Paper>
                    );

                }}
            </Query>
        )
    }

}

export default withStyles(classes)(ExibirConviadosSessao);